import api from '../api';
import { ENDPOINTS } from '../../constants/apiEndpoints';

export const fetchLoanTypeUrl = () => {
  return api.get(ENDPOINTS.fetch_loan_types.url);
};

export const createLoanTypeUrl = (payload) => {
  return api.post(ENDPOINTS.create_loan_types.url, payload);
};

export const fetchLoanTypeByIdUrl = (id) => {
  const encodedId = btoa(id.toString());
  return api.get(ENDPOINTS.fetch_loan_type_by_id.url.replace('{id}', encodedId));
};
